import history from './history'

const navigation = {
  history: () => history,
  goBack: () => {
    return history.goBack()
  },
  push: (url: string) => {
    return history.push(url)
  },
  reloadPage: () => {
    window.location.reload()
  }
}

export default navigation
